'use strict';

module.exports = function isCodePoint(cp) {
	return typeof cp === 'number' && cp >= 0 && cp <= 0x10FFFF && (cp | 0) === cp;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/isCodePoint.js
// module id = 1354
// module chunks = 0